import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, Logger } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';
import {InsolesProfileModel} from "../../../api/entity/insolesProfile.model";
import {InsolesProfileConverter} from "../../../api/entity/insolesProfile.converter";

@Injectable({
    providedIn: 'root'
})
export class InsolesProfileDataService extends AbstractDataServiceV2<InsolesProfileModel, InsolesProfileConverter> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: CustomizeHttpUrlGenerator,
        logger: Logger,
        config: DefaultDataServiceConfig,
        converter: InsolesProfileConverter) {
        super('InsolesProfile', http, httpUrlGenerator, logger, config, converter);
    }
}
